import RestrictionsService from '@/application/services/Restrictions'
import GridComponent from '@/components/src/GridComponent.vue'
import Util from  '@/application/libs/util'
import { t } from 'i18next'
import moment from 'moment'

// class fields:
let plateGroupData = {};
let plateData = {};
let plateGroupProductData = {};
let weekdayUtilizationData = {};
let productGroupPlateRestrictionsData = {};
let CDPICTPRAT = null;
let CDPICTPROD = null;
const waitForGridBuildTimeout = 50;

// constantes
const VALIDITY_SOURCES = {
    PLATE_GROUP: 'VIGENCIAGRUPOPRATO',
    PLATE: 'VIGENCIAPRATO',
    PLATE_GROUP_PRODUCT: 'VIGENCIAGRUPOPRATOPRODUTO',
    WEEKDAY_UTILIZATION: 'VIGENCIAUTILIZACAOPRATOSEMANA',
    PRODUCT_GROUP_RESTRICTIONS: 'VIGENCIAPRODUTOGRUPOPRATORESTRICACAO'
};

//methods:
const _focusGridCell = (grid, fieldName, rowIndex = 0) => {
    grid.gridControl.clearFocusedCell(); // clear current focused cells
    grid.gridControl.ensureColumnVisible(fieldName);
    grid.gridControl.startEditingCell({ rowIndex, colKey: fieldName});
};

const _getCurrentPlateGroupValidity = function() {
    return plateGroupData.currentValidity.NRVIGENCIA;
};

const filauxpratFormmater = ({ value }) => {
    let returnValue = "";
    if (value) {
        returnValue = value === 'P' ? "Padrão" : "Local";
    }
    return returnValue;
};

const addNewRowToPlateGroupPanel = function() {
    if(plateGroupData.currentValidity){
        plateGroupGridConfig.addNewRowToGrid();
    } else {
        Util.showErrorNotification({title: t('unable_to_add_dish_group_frequency'), 
        text: t('no_term_has_been_selected')})
    }
};
const addNewRowToPlateGroupProductPanel = function() {
    if(plateGroupProductData.currentValidity){
        plateGroupProductGridConfig.addNewRowToGrid();
    } else {
        Util.showErrorNotification({title: t('unable_to_add_dish_group_frequency'), 
        text: t('no_term_has_been_selected')})
    }
};
const addNewRowToPlatePanel = function() {
    if(plateData.currentValidity){
        plateGridConfig.addNewRowToGrid();
    } else {
        Util.showErrorNotification({title: t('unable_to_add_dish_frequency'), 
        text: t('no_term_has_been_selected')})
    }
};

const addNewRowToWeekdayUsagePanel = function() {
    if(weekdayUtilizationData.currentValidity){
        weekdayUtilizationGridConfig.addNewRowToGrid();
        const rowData = weekdayUtilizationGridConfig.getRowData();
        const newRow = rowData[0];
        newRow.IDUTILPRATOSERVSEG = "PREFERENCIAL";
        newRow.IDUTILPRATOSERVTER = "PREFERENCIAL";
        newRow.IDUTILPRATOSERVQUA = "PREFERENCIAL";
        newRow.IDUTILPRATOSERVQUI = "PREFERENCIAL";
        newRow.IDUTILPRATOSERVSEX = "PREFERENCIAL";
        newRow.IDUTILPRATOSERVSAB = "PREFERENCIAL";
        newRow.IDUTILPRATOSERVDOM = "PREFERENCIAL";
        
        newRow.IDUTILPRATOSERVPRIM = "PREFERENCIAL";
        newRow.IDUTILPRATOSERVULT = "PREFERENCIAL";
        newRow.IDUTILPRATOSERVSEM2 = "PREFERENCIAL";
        newRow.IDUTILPRATOSERVSEM3 = "PREFERENCIAL";
        newRow.IDUTILPRATOSERVSEM4 = "PREFERENCIAL";
        newRow.IDUTILPRATOSERVFERI = "PREFERENCIAL";
        weekdayUtilizationGridConfig.setRowData(rowData);
        weekdayUtilizationGridConfig.advancedOptions.api.startEditingCell({
            rowIndex: 0,
            colKey: "NMGRUPOPRATO"
          });
    } else {
        Util.showErrorNotification({title: t('unable_to_add_dish_frequency'), 
        text: t('no_term_has_been_selected')})
    }
};
const addNewRowToProductGroupPlateRestrictionsPanel = function() {
    if(productGroupPlateRestrictionsData.currentValidity){
        productGroupPlateRestrictionsGridConfig.addNewRowToGrid();
    } else {
        Util.showErrorNotification({title: t('unable_to_add_product_restriction_by_dish_group'), 
        text: t('no_term_has_been_selected')})
    }
};
const refreshPlateGroupFrequencyData = (selectedValidity) => {
    plateGroupData.currentValidity = selectedValidity;
    plateGroupGridConfig.dataSourceFilter.NRVIGENCIA = (selectedValidity && selectedValidity.NRVIGENCIA) || null;
    (plateGroupGridConfig.reloadData && plateGroupGridConfig.reloadData()) || 
        setTimeout(() => plateGroupGridConfig.reloadData(), waitForGridBuildTimeout);
};

const fetchPlateGroupFrequencyData = function(plateGroupPanel){
    RestrictionsService.getValidity(VALIDITY_SOURCES.PLATE_GROUP).then(res => {
        plateGroupPanel.validityOptions = res;
        plateGroupData.currentValidity = res[0];
        plateGroupPanel.selectedValidity = plateGroupData.currentValidity;
        refreshPlateGroupFrequencyData(plateGroupData.currentValidity);
    });
};
const refreshPlateGroupProductFrequencyData = (selectedValidity) => {
    plateGroupProductData.currentValidity = selectedValidity;
    plateGroupProductGridConfig.dataSourceFilter.NRVIGENCIA = (selectedValidity && selectedValidity.NRVIGENCIA) || null;
    (plateGroupProductGridConfig.reloadData && plateGroupProductGridConfig.reloadData()) || 
        setTimeout(() => plateGroupProductGridConfig.reloadData(), waitForGridBuildTimeout);
};

const fetchPlateGroupProductFrequencyData = function(plateGroupProductPanel){
    RestrictionsService.getPlateGroupProductValidity().then(res => {
        plateGroupProductPanel.validityOptions = res;
        plateGroupProductData.currentValidity = res[0];
        plateGroupProductPanel.selectedValidity = plateGroupProductData.currentValidity;
        refreshPlateGroupProductFrequencyData(plateGroupProductData.currentValidity);
    });
};
const refreshPlateFrequencyData = (selectedValidity) => {
    plateData.currentValidity = selectedValidity;
    plateGridConfig.dataSourceFilter.NRVIGENCIA = (selectedValidity && selectedValidity.NRVIGENCIA) || null;
    (plateGridConfig.reloadData && plateGridConfig.reloadData()) || 
        setTimeout(() => plateGridConfig.reloadData(), waitForGridBuildTimeout);
};

const fetchPlateFrequencyData = function(platePanel){
    RestrictionsService.getValidity(VALIDITY_SOURCES.PLATE).then(res => {
        platePanel.validityOptions = res;
        plateData.currentValidity = res[0];
        platePanel.selectedValidity = plateData.currentValidity;
        refreshPlateFrequencyData(plateData.currentValidity);
    });
};
const refreshWeekdayUtilizationData = (selectedValidity) => {
    weekdayUtilizationData.currentValidity = selectedValidity;
    weekdayUtilizationGridConfig.dataSourceFilter.NRVIGENCIA = (selectedValidity && selectedValidity.NRVIGENCIA) || null;
    (weekdayUtilizationGridConfig.reloadData && weekdayUtilizationGridConfig.reloadData()) || 
        setTimeout(() => weekdayUtilizationGridConfig.reloadData(), waitForGridBuildTimeout);
};

const fetchRegrasFlex = function (rulesFlex) {
    RestrictionsService.getParamFlexRules(rulesFlex.filterType).then(()=>{
        rulesToBeFlexibleInScenarioPostProcessingGridConfig.reloadData();
    });
};
const fetchWeekdayUtilizationData = function (weekdayUtilizationPanel) {
  RestrictionsService.getValidity(VALIDITY_SOURCES.WEEKDAY_UTILIZATION).then((res) => {
    weekdayUtilizationPanel.validityOptions = res;
    weekdayUtilizationData.currentValidity = res[0];
    weekdayUtilizationPanel.selectedValidity = weekdayUtilizationData.currentValidity;
    refreshWeekdayUtilizationData(weekdayUtilizationData.currentValidity);
  });
};
const refreshProductGroupPlateRestrictionsData = (selectedValidity) => {
    productGroupPlateRestrictionsData.currentValidity = selectedValidity;
    productGroupPlateRestrictionsGridConfig.dataSourceFilter.NRVIGENCIA = (selectedValidity && selectedValidity.NRVIGENCIA) || null;
    (productGroupPlateRestrictionsGridConfig.reloadData && productGroupPlateRestrictionsGridConfig.reloadData()) || 
        setTimeout(() => productGroupPlateRestrictionsGridConfig.reloadData(), waitForGridBuildTimeout);
};

const fetchProductGroupPlateRestrictionsData = function (productGroupPlateRestrictionsPanel) {
    RestrictionsService.getValidity(VALIDITY_SOURCES.PRODUCT_GROUP_RESTRICTIONS).then(res => {
        productGroupPlateRestrictionsPanel.validityOptions = res;
        productGroupPlateRestrictionsData.currentValidity = res?.[0];
        productGroupPlateRestrictionsPanel.selectedValidity = productGroupPlateRestrictionsData.currentValidity;
        refreshProductGroupPlateRestrictionsData(productGroupPlateRestrictionsData.currentValidity);
    });
};

const savePlateGroupFrequencyGridData = function({data, colDef}){
    RestrictionsService.savePlateGroupFrequencyGridData(data, colDef.field, 
        plateGroupGridConfig.getRowData(), plateGroupData.currentValidity)
        .then((result) => {
            if (result && result.error) {
                throw result;
            } else if(result){
                plateGroupGridConfig.enableSelection();
                let key = (result.dataset && result.dataset.data[0]) || data.NRITFREQGRPRATMES;
                key = Number(key).toString();
                if(!data.NRITFREQGRPRATMES){
                    plateGroupGridConfig.reloadData().then(a => {
                        let newElIndex = a.findIndex(ae => ae.NRITFREQGRPRATMES === key);
                        plateGroupGridConfig.gridControl.ensureIndexVisible(newElIndex, "top");
                    });
                }

                let cell = plateGroupGridConfig.gridControl.getFocusedCell();
                if ( cell ) {
                    plateGroupGridConfig.gridControl.setFocusedCell( cell.rowIndex, cell.column );
                }

                Util.showSuccessNotification({ title: t('dish_group_frequency_saved')});
            }
        })
        .catch((e = {}) => {
            Util.showErrorNotification({ title: t('unable_to_save_cymbal_group_frequency'), text: e.error });
        });
};
const saveWeekdayUtilizationGridData = function({data, colDef}){
    return RestrictionsService.saveWeekdayUtilizationGridData(data, colDef.field, 
        weekdayUtilizationGridConfig.getRowData(), weekdayUtilizationData.currentValidity)
        .then((result) => {
            if (result && result.error) {
                throw result;
            } else if(result){
                weekdayUtilizationGridConfig.enableSelection();
                let key = (result.dataset && result.dataset.data[0]) || data.NRUTILPRATOSERV;
                key = Number(key).toString();
                if(!data.NRUTILPRATOSERV){
                    const rows = weekdayUtilizationGridConfig.getRowData();
                    rows[0].NRUTILPRATOSERV = key;
                    weekdayUtilizationGridConfig.enableSelection();
                    weekdayUtilizationGridConfig.triggerIsAddingNewRowEvent();
                    delete rows[0].__is_new_row;
                }

                let cell = weekdayUtilizationGridConfig.gridControl.getFocusedCell();
                if ( cell ) {
                    weekdayUtilizationGridConfig.gridControl.setFocusedCell( cell.rowIndex, cell.column );
                }

                Util.showSuccessNotification({ title: t('using_sage_dish_group')});
            }
        })
        .catch((e = {}) => {
            Util.showErrorNotification({ title: t('unable_to_save_dish_group_usage'), text: e.error });
        })
};
const saveProductGroupPlateRestrictions = function({data, colDef}){
    RestrictionsService.saveProductGroupPlateRestrictions(data, colDef.field, 
        productGroupPlateRestrictionsGridConfig.getRowData(), productGroupPlateRestrictionsData.currentValidity)
        .then((result) => {
            if (result && result.error) {
                throw result;
            } else if(result){
                productGroupPlateRestrictionsGridConfig.enableSelection();
                let key = (result.dataset && result.dataset.data[0]) || data.NRRESTPRODGR;
                key = Number(key).toString();
                if(!data.NRRESTPRODGR){
                    productGroupPlateRestrictionsGridConfig.reloadData().then(a => {
                        let newElIndex = a.findIndex(ae => ae.NRRESTPRODGR === key);
                        productGroupPlateRestrictionsGridConfig.gridControl.ensureIndexVisible(newElIndex, "top");
                    });
                }

                let cell = productGroupPlateRestrictionsGridConfig.gridControl.getFocusedCell();
                if ( cell ) {
                    productGroupPlateRestrictionsGridConfig.gridControl.setFocusedCell( cell.rowIndex, cell.column );
                }

                Util.showSuccessNotification({ title: t('product_restriction_by_dish_group_salva')});
            }
        })
        .catch((e = {}) => {
            Util.showErrorNotification({ title: t('unable_to_save_product_restriction_by_dish_group'), text: e.error });
        });
};
const savePlateGroupProductFrequencyGridData = function({data, colDef}){
    RestrictionsService.savePlateGroupProductFrequencyGridData(data, colDef.field, 
        plateGroupProductGridConfig.getRowData(), plateGroupProductData.currentValidity)
        .then((result) => {
            if (result && result.error) {
                throw result;
            } else if(result){
                plateGroupProductGridConfig.enableSelection();
                let key = (result.dataset && result.dataset.data[0]) || data.NRITFREQPRODGRPRAT;
                key = Number(key).toString();
                if(!data.NRITFREQPRODGRPRAT){
                    plateGroupProductGridConfig.reloadData().then(a => {
                        let newElIndex = a.findIndex(ae => ae.NRITFREQPRODGRPRAT === key);
                        plateGroupProductGridConfig.gridControl.ensureIndexVisible(newElIndex, "top");
                    });
                }

                let cell = plateGroupProductGridConfig.gridControl.getFocusedCell();
                if ( cell ) {
                    plateGroupProductGridConfig.gridControl.setFocusedCell( cell.rowIndex, cell.column );
                }

                Util.showSuccessNotification({ title: t('product_frequency_by_dish_group_salva')});
            }
        })
        .catch((e = {}) => {
            Util.showErrorNotification({ title: t('unable_to_save_product_frequency_by_dish_group'), text: e.error });
        });
};

const savePlateFrequencyGridData = function({data, colDef}){
    RestrictionsService.savePlateFrequencyGridData(data, colDef.field, 
        plateGridConfig.getRowData(), plateData.currentValidity)
        .then((result) => {
            if (result && result.error) {
                throw result;
            } else if(result){
                plateGridConfig.enableSelection();
                let key = (result.dataset && result.dataset.data[0]) || data.NRITFREQPRATMES;
                key = Number(key).toString();
                if(!data.NRITFREQPRATMES){
                    plateGridConfig.reloadData().then(a => {
                        let newElIndex = a.findIndex(ae => ae.NRITFREQPRATMES === key);
                        plateGridConfig.gridControl.ensureIndexVisible(newElIndex, "top");
                    });
                }

                let cell = plateGridConfig.gridControl.getFocusedCell();
                if ( cell ) {
                    plateGridConfig.gridControl.setFocusedCell( cell.rowIndex, cell.column );
                }
                
                Util.showSuccessNotification({ title: t('dish_frequency_saved')});
            }
        })
        .catch((e = {}) => {
            Util.showErrorNotification({ title: t('unable_to_save_dish_frequency'), text: e.error });
        });
};

const saveValidity = (validityData, panel, modal, from) => {
    RestrictionsService.saveValidity(validityData, from)
        .then(() => {
            RestrictionsService.getValidity(from).then((res) => {
                panel.validityOptions = res;
            });
            modal.hide("validityModal");
            Util.showSuccessNotification({ title: t("term_saved") });
        })
        .catch((e) => {
            Util.showErrorNotification({
                title: t("unable_to_save_term"),
                text: e.error
            });
        });
};

const replicateValidity = async (validityData, panel, modal, from) => {
    let table;

    switch(from){
        case VALIDITY_SOURCES.PLATE: 
            table = 'FREQPRATMES';
            break;
        case VALIDITY_SOURCES.PLATE_GROUP: 
            table = 'FREQGRPRATMES';
            break;
        case VALIDITY_SOURCES.PRODUCT_GROUP_RESTRICTIONS: 
            table = 'RESTPRODGR';
            break;
        case VALIDITY_SOURCES.WEEKDAY_UTILIZATION: 
            table = 'UTILPRATOSERV';
            break;
    }
    
    const nrvigencia_origem = panel.selectedValidity.NRVIGENCIA;

    RestrictionsService.saveValidity(validityData, from, true, nrvigencia_origem)
        .then(() => {
            RestrictionsService.getValidity(from).then((res) => {
                panel.validityOptions = res;
            });
            modal.hide("validityModal");
            Util.showSuccessNotification({ title: t("term_saved") });
        })
        .catch((e) => {
            Util.showErrorNotification({
                title: t("unable_to_save_term"),
                text: e.error
            });
        });


};

const saveChangedPlateGroupValidity = (validityDetails, plateGroupPanel, modal) => {
    RestrictionsService.editPlateGroupValidity(
        validityDetails, 
        plateGroupData.currentValidity.NRVIGENCIA
    ).then((saveResult) => {
        if(saveResult && saveResult.error){
            throw saveResult;
        } else {
            RestrictionsService.getValidity(VALIDITY_SOURCES.PLATE_GROUP).then(res => {
                plateGroupPanel.validityOptions = res;
                plateGroupPanel.selectedValidity.DESCRICAO = validityDetails.description;
            });
            modal.hide("editValidityModal");
            Util.showSuccessNotification({ title: t('term_saved')});
        }
    })
    .catch(e => {
        Util.showErrorNotification({ title: t('unable_to_save_term'), text: e.error });
    });
};
const saveChangedPlateGroupProductValidity = (validityDetails, plateGroupProductPanel, modal) => {
    RestrictionsService.editPlateGroupProductValidity(validityDetails, plateGroupProductData.currentValidity.NRVIGENCIA)
    .then((saveResult) => {
        if(saveResult && saveResult.error){
            throw saveResult;
        } else {
            RestrictionsService.getPlateGroupProductValidity().then(res => {
                plateGroupProductPanel.validityOptions = res;
                plateGroupProductPanel.selectedValidity.DESCRICAO = validityDetails.description;
            });
            modal.hide("editValidityModal");
            Util.showSuccessNotification({ title: t('term_saved')});
        }
    })
    .catch(e => {
        Util.showErrorNotification({ title: t('unable_to_save_term'), text: e.error });
    });
};
const saveChangedWeekdayUtilizationValidity = (validityDetails, weekdayUtilizationPanel, modal) => {
    RestrictionsService.editWeekdayUtilizationValidity(
        validityDetails, 
        weekdayUtilizationData.currentValidity.NRVIGENCIA
    ).then((saveResult) => {
        if(saveResult && saveResult.error){
            throw saveResult;
        } else {
            RestrictionsService.getValidity(VALIDITY_SOURCES.WEEKDAY_UTILIZATION).then(res => {
                weekdayUtilizationPanel.validityOptions = res;
                weekdayUtilizationPanel.selectedValidity.DESCRICAO = validityDetails.description;
            });
            modal.hide("editValidityModal");
            Util.showSuccessNotification({ title: t('term_saved')});
        }
    })
    .catch(e => {
        Util.showErrorNotification({ title: t('unable_to_save_term'), text: e.error });
    });
};
const saveChangedProductGroupPlateRestrictionsValidity = (validityDetails, productGroupPlateRestrictionsPanel, modal) => {
    RestrictionsService.editProductGroupPlateRestrictionsValidity(
      validityDetails, 
      productGroupPlateRestrictionsData.currentValidity.NRVIGENCIA
    )
    .then((saveResult) => {
      if (saveResult && saveResult.error) {
        throw saveResult;
      } else {
        RestrictionsService.getValidity(VALIDITY_SOURCES.PRODUCT_GROUP_RESTRICTIONS).then(res => {
          productGroupPlateRestrictionsPanel.validityOptions = res;
          productGroupPlateRestrictionsPanel.selectedValidity.DESCRICAO = validityDetails.description;
        });
        modal.hide("editValidityModal");
        Util.showSuccessNotification({ title: t('term_saved') });
      }
    })
    .catch(e => {
      Util.showErrorNotification({ title: t('unable_to_save_term'), text: e.error });
    });
};
const saveChangedPlateValidity = (validityDetails, platePanel, modal) => {
    RestrictionsService.editPlateValidity(validityDetails, plateData.currentValidity.NRVIGENCIA)
    .then((saveResult) => {
        if(saveResult && saveResult.error){
            throw saveResult;
        } else {
            RestrictionsService.getValidity(VALIDITY_SOURCES.PLATE).then(res => {
                platePanel.validityOptions = res;
                platePanel.selectedValidity.DESCRICAO = validityDetails.description;
            });
            modal.hide("editValidityModal");
            Util.showSuccessNotification({ title: t('term_saved')});
        }
    })
    .catch(e => {
        Util.showErrorNotification({ title: t('unable_to_save_term'), text: e.error });
    });
};


const buildMessage = (status) => {
    let message = [];
    status.forEach((error) => {
        let msg = error.DSERRO;
        msg = msg.replace('_MSGSTA_CONSISTE_GRUPOPRATO', '');
        msg = msg.replace("_MSGEND_", "");
        msg = msg.split("$$");
        message.push({ CDFILIAL: msg[1], CDSERVFILI: msg[2], CDGRUPRAT: msg[3] });
    });
    return message;
};

const exportValidityProcedureCaller = function(objectToSend, modal, data) {
    const table = objectToSend.table;
    RestrictionsService.exportValidityProcedureCaller(objectToSend).then((response) => {
        if(response.status.length > 0) {
            data._showLoad = true;
            const status = response.status;
            const messages = buildMessage(status);
            const messageTitle = t(table === 'FREQPRATMES' ? 'erro_export_prato' : 'erro_export_grupoprato');
            const typeLabel = t(table === 'FREQPRATMES' ? 'plate' : 'plateGroup');

            const modalProps = {
                messages,
                messageTitle,
                typeLabel,
                t
            };
            modal.show({
                template:`
                    <div class="validity-form-root" style="margin: 0; padding: 25px; width: calc(100% - 50px);"> 
                        <h3 class="title"> {{messageTitle}} </h3>
                        <div style="max-height: 500px; overflow: auto; padding: 30px 0; width: 100%;">
                            <span v-for="message in messages" style="display:block; margin: 10px;"> {{t('unit')}}: {{message.CDFILIAL}} {{t('service')}}: {{message.CDSERVFILI}} 
                            {{typeLabel}}: {{message.CDGRUPRAT}}</span>
                        </div>
                        <div>
                            <button class="button" style="margin: 15px auto; display: block; min-width: 200px;" @click="close"> OK </button>
                        </div>
                    </div>
                `,
                props: ['messages','messageTitle', 'typeLabel', 't'],
                methods:{
                    close(){this.$emit('close');}
                }
            }, modalProps, {
                height:'auto',
                width:'69%',
            });
        } else {
            data._showLoad = true;
            Util.showSuccessNotification({ title: t('successful_export')});
            modal.hide('export-form-modal');
        }
    }).catch((error) => {
        data._showLoad = true;
        data._messageError.title = t('export_error');
        data._messageError.message = error;
        modal.show("messageError");
        //Util.showErrorNotification({title: error});
    }) ;
};

const exportModalForm = function(objectToSend, modal, data) {
    let rowsToExport = rulesToBeFlexibleInScenarioPostProcessingGridConfig.getRowData();
    let idfilterType = rulesToBeFlexibleInScenarioPostProcessingGridConfig.panel.filterType;
    RestrictionsService.exportModalForm(objectToSend, idfilterType, rowsToExport).then(() => {
        Util.showSuccessNotification({ title: t('successful_export')});
        data.showLoad = true;
        modal.hide('export-modal');
    }).catch((error) => {
        data.showLoad = true;
        console.log(error);
    });
};

//TODO, move to object map
const _getSearchVarByName = function(name){
    let ret = {};
    if(name === "plateGroup"){
        ret = plateGroupData;
    } else if(name === "plate") {
        ret = plateData;
    } else if(name === "plateGroupProduct") {
        ret = plateGroupProductData;
    } else if(name === "weekdayUtilization") {
        ret = weekdayUtilizationData;
    } else if(name === "productGroupRestrictions") {
        ret = productGroupPlateRestrictionsData;
    }
    return ret;
}

const showValidityEditorPopUp = (modal, panelName) => {
    let searchVar = _getSearchVarByName(panelName);
    if(searchVar.currentValidity){
        modal.show("editValidityModal", {});
    } else {
        Util.showErrorNotification({title: t('unable_to_edit_term'), 
        text: t('no_term_has_been_selected')})
    }
};

const deleteGroupPanelRows = (plateGroupPanel) => {
    plateGroupGridConfig.deleteCheckedRows(RestrictionsService.removePlateGroupFrequency)
    .then(() => plateGroupPanel.hasCheckedRows = false)
    .catch(e => {
        Util.showErrorNotification({ title: t('error_deleting_frequency'), text: e.error })
    });
};

const deletePlatePanelRows = (platePanel) => {
    return plateGridConfig.deleteCheckedRows(RestrictionsService.removePlateFrequency)
    .then(() => platePanel.hasCheckedRows = false)
    .catch(e => {
        Util.showErrorNotification({ title: t('error_deleting_frequency'), text: e.error })
    });
};

const deleteGroupProductPanelRows = (plateGroupProductPanel) => {
    plateGroupProductGridConfig.deleteCheckedRows(RestrictionsService.removePlateGroupProductFrequency)
    .then(() => plateGroupProductPanel.hasCheckedRows = false)
    .catch(e => {
        Util.showErrorNotification({ title: t('error_deleting_frequency'), text: e.error })
    });
};

const deleteWeekdayUsagePanelRows = (weekdayUtilizationPanel) => {
    weekdayUtilizationGridConfig.deleteCheckedRows(RestrictionsService.removeWeekdayUsage)
    .then(() => weekdayUtilizationPanel.hasCheckedRows = false)
    .catch(e => {
        Util.showErrorNotification({ title: t('error_deleting_dish_group_usage_in_Week'), text: e.error })
    });
};

const deleteProductGroupPlateRestrictionsPanelRows = (productGroupPlateRestrictionsPanel) => {
    productGroupPlateRestrictionsGridConfig.deleteCheckedRows(RestrictionsService.removeProductGroupPlateRestrictions)
    .then(() => productGroupPlateRestrictionsPanel.hasCheckedRows = false)
    .catch(e => {
        Util.showErrorNotification({ title: t('error_deleting_product_restriction_by_dish_group'), text: e.error })
    });
};

const _deleteValidityData = {
    productGroupRestrictions: {
        url: "VIGENCIAPRODUTOGRUPOPRATORESTRICACAO", 
        callback: fetchProductGroupPlateRestrictionsData,
        errMessage: t('duration_of_product_restriction_by_dish_group'),
        addCDFILIAL: true
    },
    weekdayUtilization: {
        url: "VIGENCIAUTILIZACAOPRATOSEMANA", 
        callback: fetchWeekdayUtilizationData,
        errMessage: t('validity'),
        addCDFILIAL: true
    },
    plateGroupProduct: {
        url: "VIGENCIAGRUPOPRATOPRODUTO", 
        callback: fetchPlateGroupProductFrequencyData,
        errMessage: t('validity'),
        addCDFILIAL: false
    },
    plateGroup: {
        url: "VIGENCIAGRUPOPRATO", 
        callback: fetchPlateGroupFrequencyData,
        errMessage: t('validity'),
        addCDFILIAL: false
    },
    plate: {
        url: "VIGENCIAPRATO",
        callback: fetchPlateFrequencyData,
        errMessage: t('validity'),
        addCDFILIAL: false
    }
};

const _deleteValidity = (which, uiPanel, modal, forceDelete = false) => {
    let data = _getSearchVarByName(which);
    let addCDFILIAL = _deleteValidityData[which].addCDFILIAL;
    return RestrictionsService.deleteValidity(data.currentValidity, forceDelete, _deleteValidityData[which].url, addCDFILIAL)
    .then((res) => {
        if(res.dataset && res.dataset.data.length){
            _showDeleteValidityChildrenDependencyDialog(which, uiPanel, modal, res.dataset.data)
        } else {
            _deleteValidityData[which].callback(uiPanel);
        }
    })
    .catch(() => Util.showErrorNotification({ title: `Erro ao apagar ${_deleteValidityData[which].errMessage}`}));
};

const _showDeleteValidityChildrenDependencyDialog = (which, uiPanel, modal, children) => {
    modal.show({
        template:`
            <div class="validity-form-root dialog-box"  style="width: auto; margin: 0 auto; max-height: 300px; overflow-y: auto;"> 
                <h5 class="title" style="text-align: center; margin-left: 0; margin-top: 10px; font-weight: normal; font-size: 1rem;">{{$t('valid_exclusion_validity')}}</h5>
                <ul class="service-list">
                    <li v-for="child in children"> {{child.SERVICO}} </li>
                </ul>
                <h5 class="title" style="text-align: center; margin-left: 0; margin-top: 10px; font-weight: normal; font-size: 1rem;"> {{$t('confirm_deletion')}} </h5>
                <div class="dialog-button-container" style="margin-top: 10px; display: flex; justify-content: center;">
                    <button class="button confirmation-dialog-button" @click="close" style="font-size: 0.9rem; padding: 9px 30px; margin: 5px;"> {{$t('no')}} </button>
                    <button class="button confirmation-dialog-button" @click="deleteValidity" style="font-size: 0.9rem; padding: 9px 30px; margin: 5px;"> {{$t('yes')}} </button>
                </div>    
            </div>
        `,
        props: ['children'],
        methods:{
            deleteValidity(){
                _deleteValidity(which, uiPanel, modal, true).then(() => this.$emit('close'))
            },
            close(){this.$emit('close');}
        }
    }, {children}, {
        height:'auto',
        width:'325px',
    });
};
const showDeleteValidityConfirmationDialog = (which, uiPanel, modal) => {
    if(uiPanel.selectedValidity){
        modal.show({
            template:`
                <div class="validity-form-root" style="width: auto; margin: 0 auto;">
                  <h5 class="title" style="text-align: center; margin-bottom: 10px; margin-left: 0; margin-top: 10px; font-weight: normal; font-size: 1rem;">
                    {{$t('validation_delete_validity')}} ?
                  </h5>
                  <div class="dialog-button-container" style="margin-top: 10px; display: flex; justify-content: center;">
                    <button class="button confirmation-dialog-button" 
                            @click="close" 
                            style="font-size: 0.9rem; padding: 9px 30px; margin: 5px;">
                      {{$t('no')}}
                    </button>
                    <button class="button confirmation-dialog-button" 
                            @click="deleteValidity" 
                            style="font-size: 0.9rem; padding: 9px 30px; margin: 5px;">
                      {{$t('yes')}}
                    </button>
                  </div>
                </div>
            `,
            methods:{
                deleteValidity(){
                    _deleteValidity(which, uiPanel, modal).then(() => this.$emit('close'))
                },
                close(){this.$emit('close');}
            }
        }, {}, {
            height:'100px',
            width:'325px',
        });
    } else {
        Util.showNotification({title: t('error_delete_validity'), text: t('no_term_has_been_selected')});
    }
};
// grid definitions:

const plateGroupGridConfig = {
    columnDefs: [
        { headerValueGetter: ()=> {return t('groupings') } , field: "NMAGRUPGRPRAT", checkboxSelection: true, editable: false,
        onCellDoubleClicked: () => _focusGridCell(plateGroupGridConfig, "NMGRUPOPRATO"),
        sortable: true, filter: "agTextColumnFilter"
        },
        { headerValueGetter: ()=> {return t('plate_groups') } , field: "NMGRUPOPRATO", 
        editable: (e) => !e.data.NRITFREQGRPRATMES, cellEditor: "vSelectCellEditor",
        sortable: true, filter: "agTextColumnFilter",
        cellEditorParams: {
            optionsSearchFunction: () => RestrictionsService.getServicePlateGroup(_getCurrentPlateGroupValidity()),
            valueColumn: "NRGRUPOPRATOSERV",
            labelColumn: "NMGRUPOPRATO",
            remoteFilter: false,
            searchableColumns: ["NMGRUPOPRATO"],
            outDataColumns: ["NMAGRUPGRPRAT", "NRGRUPOPRATOSERV"]
        },},
        { headerValueGetter: ()=> {return t('nickname') } , field: "NMFANTGRUPOPRATOSERV", sortable: true, editable: false},
        { headerValueGetter: ()=> {return t('month_min') } , field: "NRMINFREQGRPRATMES", sortable: true},
        { headerValueGetter: ()=> {return t('month_max') } , field: "NRMAXFREQGRPRATMES", sortable: true},
        { headerValueGetter: ()=> {return t('week_max') } , field: "NRMAXFREQGRPRATSEM", sortable: true},
        { headerValueGetter: ()=> {return t('columns') } , field: "COLUNA", sortable: true, editable: false},
    ],
    defaultColDef: {resizable: true, lockVisible: true, editable: true},
    lazyLoad: true,
    dataSource: RestrictionsService.getPlateGroupFrequencyGridData,
    dataSourceFilter: {},
    onCellValueChanged: savePlateGroupFrequencyGridData,
};

const plateGridConfig = {
    columnDefs: [
        { headerValueGetter: ()=> {return t('tree') } , field: "CDFILAUXPRAT", checkboxSelection: true, editable: false,
        onCellDoubleClicked: () => _focusGridCell(plateGridConfig, "CDPRATO"), valueFormatter: filauxpratFormmater,
        },
        { 
            headerValueGetter: ()=> {return t('dish_code') } , field: "CDPRATO", cellClass: ["select-350"],
            editable: (e) => !e.data.NRITFREQPRATMES, cellEditor: "vSelectCellEditor",
            sortable: true, filter: "agTextColumnFilter",
            filterParams: {defaultOption: 'startsWith'},
            valueFormatter: ({value}) => Util.insertChar(value, CDPICTPRAT, '.'),
            cellEditorParams: {
                optionsSearchFunction: Util.debounce((v)=>{
                    return RestrictionsService.getPlate(v, plateData.currentValidity.NRVIGENCIA);
                }, 400),
                valueColumn: "CDPRATO",
                labelColumn: "CDPRATO",
                searchableColumns: ["CDPRATO" , "NMPRATO", "CDFILAUXPRAT"],
                outDataColumns: ["NMPRATO", "CDPRATO", "CDFILAUXPRAT"],
            },
        },
        { headerValueGetter: ()=> {return t('dish_name') } , field: "NMPRATO", editable: false,
        onCellDoubleClicked: () => _focusGridCell(plateGridConfig, "CDPRATO"),
        sortable: true, filter: "agTextColumnFilter"
        },
        { headerValueGetter: ()=> {return t('month_min') } , field: "NRMINFREQPRATMES", sortable: true},
        { headerValueGetter: ()=> {return t('month_max') } , field: "NRMAXFREQPRATMES", sortable: true},
        { headerValueGetter: ()=> {return t('week_max') } , field: "NRMAXFREQPRATSEM", sortable: true},
    ],
    defaultColDef: {resizable: true, lockVisible: true, editable: true},
    lazyLoad: true,
    dataSource: RestrictionsService.getPlateFrequencyGridData,
    dataSourceFilter: {},
    onCellValueChanged: savePlateFrequencyGridData,
};

const plateGroupProductGridConfig = {
    columnDefs: [
        { headerValueGetter: ()=> {return t('groupings') } , field: "NMAGRUPGRPRAT", checkboxSelection: true, editable: false,
        onCellDoubleClicked: () => _focusGridCell(plateGroupProductGridConfig, "NMGRUPOPRATO"),
        },
        { headerValueGetter: ()=> {return t('plate_groups') } , field: "NMGRUPOPRATO", 
        editable: (e) => !e.data.NRITFREQPRODGRPRAT, cellEditor: "vSelectCellEditor",
        cellEditorParams: {
            optionsSearchFunction: () => RestrictionsService.getPlateGroup(),
            valueColumn: "NRGRUPOPRATOSERV",
            labelColumn: "NMGRUPOPRATO",
            remoteFilter: false,
            searchableColumns: ["NMGRUPOPRATO"],
            outDataColumns: ["NMAGRUPGRPRAT", "NRGRUPOPRATOSERV"]
        },},
        { headerValueGetter: ()=> {return t('product_code') } , field: "CDARVPROD", 
        editable: (e) => !e.data.NRITFREQPRODGRPRAT, cellEditor: "vSelectCellEditor",
        cellClass: ["select-350"],
        valueFormatter: ({value}) => Util.insertChar(value, CDPICTPROD, '.'),
        filterParams: {defaultOption: 'startsWith'},
        cellEditorParams: {
            optionsSearchFunction: RestrictionsService.getProducts,
            valueColumn: "CDPRODUTO",
            labelColumn: "CDARVPROD",
            searchableColumns: ["CDARVPROD", "NMPRODUTO"],
            outDataColumns: ["CDPRODUTO", "NMPRODUTO"]
        },},
        { headerValueGetter: ()=> {return t('product_name') } , field: "NMPRODUTO", editable: false,
            onCellDoubleClicked: () => _focusGridCell(plateGroupProductGridConfig, "CDARVPROD"),
        },
        { headerValueGetter: ()=> {return t('month_min') } , field: "NRMINPRODGRPRAT", sortable: true, filter: null},
        { headerValueGetter: ()=> {return t('month_max') } , field: "NRMAXPRODGRPRAT", sortable: true, filter: null},
        { headerValueGetter: ()=> {return t('week_max') } , field: "NRMAXPRODGRPRATSEM", sortable: true, filter: null},
    ],
    defaultColDef: {resizable: true, lockVisible: true, editable: true, sortable: true, filter: "agTextColumnFilter"},
    lazyLoad: true,
    dataSource: RestrictionsService.getPlateGroupProductFrequencyGridData,
    dataSourceFilter: {},
    onCellValueChanged: savePlateGroupProductFrequencyGridData,
};

const _usageLabelValMap = {"RESTRICAO": t('restriction'), "OBRIGATORIO": t('required'), "PREFERENCIAL": t('preferential')};
const _usageFromatter = ({value}) => _usageLabelValMap[value];

const _weekdayCellTemplate = {
    cellEditor: "vSelectCellEditor",
    cellEditorParams:()=>Util.translateVSelectCellEditor({
        options: [
            {value: "RESTRICAO", label: "RESTRICAO"}, 
            {value: "OBRIGATORIO", label: "OBRIGATORIO"}, 
            {value: "PREFERENCIAL", label: "PREFERENCIAL"}
        ]
    }),
    valueFormatter: ({ value }) => t(value)
};

//const _getWeekdayCellDefault = () => JSON.parse(JSON.stringify(_weekdayCellTemplate));
const _getWeekdayCellDefault = () => {return{..._weekdayCellTemplate}};


const productGroupPlateRestrictionsGridConfig = {
    columnDefs: [
        { headerValueGetter: ()=> {return t('groupings')} , field: "NMAGRUPGRPRAT", checkboxSelection: true, editable: false,
            onCellDoubleClicked: () => _focusGridCell(productGroupPlateRestrictionsGridConfig, "NMGRUPOPRATO"),
        },
        { headerValueGetter: ()=> {return t('plate_groups')} , field: "NMGRUPOPRATO", 
            editable: (e) => !e.data.NRRESTPRODGR, cellEditor: "vSelectCellEditor", //TODO
            cellEditorParams: {
            optionsSearchFunction: () => RestrictionsService.getPlateGroup(),
            valueColumn: "NRGRUPOPRATOSERV",
            labelColumn: "NMGRUPOPRATO",
            remoteFilter: false,
            searchableColumns: ["NMGRUPOPRATO"],
            outDataColumns: ["NMAGRUPGRPRAT", "NRGRUPOPRATOSERV"]
        },},
        { headerValueGetter: ()=> {return t('product_code') }, field: "CDARVPROD", 
        editable: (e) => !e.data.NRRESTPRODGR, cellEditor: "vSelectCellEditor",
        cellClass: ["select-350"],
        valueFormatter: ({value}) => Util.insertChar(value, CDPICTPROD, '.'),
        filterParams: {defaultOption: 'startsWith'},
        cellEditorParams: {
            optionsSearchFunction: RestrictionsService.getProducts,
            valueColumn: "CDPRODUTO",
            labelColumn: "CDARVPROD",
            searchableColumns: ["CDARVPROD", "NMPRODUTO"],
            outDataColumns: ["CDPRODUTO", "NMPRODUTO"]
        },},
        { headerValueGetter: ()=> {return t('product_name') }, field: "NMPRODUTO", editable: false,
        onCellDoubleClicked: () => _focusGridCell(productGroupPlateRestrictionsGridConfig, "CDARVPROD"),
        }
    ],
    defaultColDef: {resizable: true, lockVisible: true, editable: true, sortable: true, filter: "agTextColumnFilter"},
    lazyLoad: true,
    dataSource: RestrictionsService.getProductGroupPlateRestrictions,
    dataSourceFilter: {},
    onCellValueChanged: saveProductGroupPlateRestrictions,
};
const weekdayUtilizationGridConfig = {
    columnDefs: [
        { headerValueGetter: ()=> {return t('groupings') } , field: "NMAGRUPGRPRAT", checkboxSelection: true, editable: false,
            onCellDoubleClicked: () => _focusGridCell(weekdayUtilizationGridConfig, "NMGRUPOPRATO"),
            sortable: true, filter: "agTextColumnFilter"
        },
        { headerValueGetter: ()=> {return t('plate_groups') } , field: "NMGRUPOPRATO", 
            editable: (e) => !e.data.NRUTILPRATOSERV, cellEditor: "vSelectCellEditor",
            sortable: true, filter: "agTextColumnFilter",
            cellEditorParams: {
            optionsSearchFunction: () => RestrictionsService.getGruoupForNewWeekdayUsage(
                weekdayUtilizationData.currentValidity.NRVIGENCIA),
            valueColumn: "NRGRUPOPRATOSERV",
            labelColumn: "NMGRUPOPRATO",
            remoteFilter: false,
            searchableColumns: ["NMGRUPOPRATO"],
            outDataColumns: ["NMAGRUPGRPRAT", "NRGRUPOPRATOSERV"],
        },},
        { headerValueGetter: ()=> {return t('subtitle2_monday') } , field: "IDUTILPRATOSERVSEG", ..._getWeekdayCellDefault()},
        { headerValueGetter: ()=> {return t('subtitle2_tuesday') } , field: "IDUTILPRATOSERVTER", ..._getWeekdayCellDefault()},
        { headerValueGetter: ()=> {return t('subtitle2_wednesday') } , field: "IDUTILPRATOSERVQUA", ..._getWeekdayCellDefault()},
        { headerValueGetter: ()=> {return t('subtitle2_thursday') } , field: "IDUTILPRATOSERVQUI", ..._getWeekdayCellDefault()},
        { headerValueGetter: ()=> {return t('subtitle2_friday') } , field: "IDUTILPRATOSERVSEX", ..._getWeekdayCellDefault()},
        { headerValueGetter: ()=> {return t('subtitle2_saturday') } , field: "IDUTILPRATOSERVSAB", ..._getWeekdayCellDefault()},
        { headerValueGetter: ()=> {return t('subtitle2_sunday') } , field: "IDUTILPRATOSERVDOM", ..._getWeekdayCellDefault()},
        { headerValueGetter: ()=> {return t('first_occurrence') } , field: "IDUTILPRATOSERVPRIM", ..._getWeekdayCellDefault()},
        { headerValueGetter: ()=> {return t('second_occurrence') } , field: "IDUTILPRATOSERVSEM2", ..._getWeekdayCellDefault()},
        { headerValueGetter: ()=> {return t('third_occurrence') } , field: "IDUTILPRATOSERVSEM3", ..._getWeekdayCellDefault()},
        { headerValueGetter: ()=> {return t('fourth_occurrence') } , field: "IDUTILPRATOSERVSEM4", ..._getWeekdayCellDefault()},
        { headerValueGetter: ()=> {return t('last_occurrence') } , field: "IDUTILPRATOSERVULT", ..._getWeekdayCellDefault()},
        { headerValueGetter: ()=> {return t('subtitle_holiday') } , field: "IDUTILPRATOSERVFERI", ..._getWeekdayCellDefault()},
    ],
    defaultColDef: {resizable: true, lockVisible: true, editable: true},
    lazyLoad: true,
    dataSource: RestrictionsService.getPlateWeekdayUtilization,
    dataSourceFilter: {},
    onCellValueChanged: saveWeekdayUtilizationGridData,
};

const onChangeCellValue = async function(params){
    let idfilterType = rulesToBeFlexibleInScenarioPostProcessingGridConfig.panel.filterType;
    await RestrictionsService.saveChangeOnIdflexivelRow(params.colDef, params.data, idfilterType);
    rulesToBeFlexibleInScenarioPostProcessingGridConfig.reloadData();
};

const SNmap = { "S": 'Sim', "N": 'Não'};

const rulesToBeFlexibleInScenarioPostProcessingGridConfig = {
    columnDefs: [
        { headerValueGetter: ()=> {return t('order')}, field: "NRORDEMREGRA", editable: false},
        { headerValueGetter: ()=> {return t('rule')}, field: "DSREGRAFLEX", editable: false, rowDrag:true, 
            cellRenderer: ( { value } ) => {
                return t(value);
            }
        },
        { headerValueGetter: ()=> {return t('allows_flexibility')}, field: "IDFLEXIVEL",editable: true, cellEditor: "optionsBunchCellEditor",
            cellEditorParams: ()=>Util.translateOptionsBunchCellEditor({options: SNmap}),
            lockVisible: true,
            valueFormatter: ({ value }) => t(SNmap[value]),
            onCellValueChanged: onChangeCellValue
        }
    ],
    defaultColDef: {resizable: true, lockVisible: true, editable: true},
    dataSource: async () => {
        let response = await RestrictionsService.getRulesToBeFlexibleInScenarioPostProcessing();
        let idfilterType = response.dataset.data.hasIDREGRAPORFILIAL ? "porUnidade" : "geral";
        if (rulesToBeFlexibleInScenarioPostProcessingGridConfig.panel) {
            rulesToBeFlexibleInScenarioPostProcessingGridConfig.panel.filterType = idfilterType;
        }
        return response.dataset.data.row.sort((a, b) => a.NRORDEMREGRA - b.NRORDEMREGRA);
    }
};
const updRestoreFlexibleRules = async function(){
    let idfilterType = rulesToBeFlexibleInScenarioPostProcessingGridConfig.panel.filterType;
    await RestrictionsService.updRestoreFlexibleRules(idfilterType);
    this.rulesToBeFlexibleInScenarioPostProcessingGridConfig.reloadData();
    Util.showNotification({
        text: t('save_as', {PARAM: `${moment().format('HH:mm:ss')}`}),
        title: t('rules_to_Be_Flexible_In_Scenario_PostProcessing')
    });
}

const moveRulePosition = async function(start, destiny){
    let ruleStart = start;
    let ruleDestiny = destiny;
    let paramsUpdate;
    let idfilterType = rulesToBeFlexibleInScenarioPostProcessingGridConfig.panel.filterType;

    paramsUpdate = {
        "NROTMREGRAFLEX_ORI": ruleStart.NROTMREGRAFLEX,
        "NROTMREGRAFLEX_DEST": ruleDestiny.NROTMREGRAFLEX,
        "FILTERTYPE": idfilterType
    };    
    await RestrictionsService.updateOrderRule(paramsUpdate);

    this.rulesToBeFlexibleInScenarioPostProcessingGridConfig.reloadData();
    Util.showNotification({
        text: t('save_as', {PARAM: `${moment().format('HH:mm:ss')}`}),
        title: t('rules_to_Be_Flexible_In_Scenario_PostProcessing')
    });
};

const init = ({validityFormData}) => {
    CDPICTPRAT = Util.getFilterInSession().CDPICTPRAT;
    CDPICTPROD = Util.getFilterInSession().CDPICTPROD;
    RestrictionsService.getValidityObservations().then(r => {
        validityFormData.observationOptions = r;
    }).catch(() => {console.error("couldn't fetch validity observation options")});
};

export default {
    registerContext:function(){},
    init,
    
    plateGroupGridConfig,    
    plateGridConfig,
    plateGroupProductGridConfig,
    weekdayUtilizationGridConfig,
    productGroupPlateRestrictionsGridConfig,
    rulesToBeFlexibleInScenarioPostProcessingGridConfig,
    updRestoreFlexibleRules,
    moveRulePosition,
    fetchPlateGroupFrequencyData,
    refreshPlateGroupFrequencyData,
    deleteGroupPanelRows,
    deletePlatePanelRows,
    deleteGroupProductPanelRows,
    deleteWeekdayUsagePanelRows,
    deleteProductGroupPlateRestrictionsPanelRows,
    saveValidity,
    replicateValidity,
    saveChangedPlateGroupValidity,
    saveChangedPlateGroupProductValidity,
    saveChangedWeekdayUtilizationValidity,
    saveChangedProductGroupPlateRestrictionsValidity,
    saveChangedPlateValidity,
    addNewRowToPlateGroupPanel,
    addNewRowToPlatePanel,
    addNewRowToPlateGroupProductPanel,
    addNewRowToWeekdayUsagePanel,
    addNewRowToProductGroupPlateRestrictionsPanel,
    showValidityEditorPopUp,
    exportValidityProcedureCaller,
    exportModalForm,
    
    fetchPlateFrequencyData,
    refreshPlateFrequencyData,
    refreshPlateGroupProductFrequencyData,
    fetchPlateGroupProductFrequencyData,
    refreshWeekdayUtilizationData,
    fetchRegrasFlex,
    fetchWeekdayUtilizationData,
    refreshProductGroupPlateRestrictionsData,
    fetchProductGroupPlateRestrictionsData,
    
    showDeleteValidityConfirmationDialog
}